import { inventoryProductService } from "../../../../../Api/Services/InventoryService/inventoryProduct";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ICreateInventoryProductResponse, IEditInventoryProductResponse, IInventoryProductPayload } from "../../types";

export const getEditInventoryProductThunk = createServiceAsyncThunk<
    IEditInventoryProductResponse,
    number
>(
    ACTION_NAMES.EDIT_INVENTORY_PRODUCT,
    (id) => inventoryProductService.getEditInventoryProduct(id),
    ERROR_MESSAGES.EDIT_INVENTORY_PRODUCT_FAILURE
);

const editInventoryProductSlice = createGenericSlice<
    IEditInventoryProductResponse,
    number
>(
    SLICE_NAMES.EDIT_INVENTORY_PRODUCT_SLICE,
    getEditInventoryProductThunk
);

export const {
    clearError: clearEditInventoryProductError,
    clearSuccessMessage: clearEditInventoryProductSuccessMessage,
} = editInventoryProductSlice.actions;

export default editInventoryProductSlice.reducer;
